export default __webpack_public_path__ + "static/media/v-banner-2020-6-16.0c85fa18.jpg";